// Copied from string.rb

export const UUID_EXACT_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export default function looksLikeUuid(str: string) {
    return UUID_EXACT_REGEX.test(str);
}
